function SectionHeader() {
  return (
    <div
      style={{
        textAlign: 'center',
      }}
    >
      <h3>Medya Teklifi Başlık</h3>
      <p>
        Yazdığınız maddede kullanılmasını istediğiniz, telifi size ait veya size ait olmayan dosyaları bu bölümde gönderebilirsiniz. <strong>"Ekle"</strong>{' '}
        butonuna basarak daha fazla dosya ekleyebilirsiniz.
      </p>
    </div>
  );
}
export default SectionHeader;
